export default __webpack_public_path__ + "static/media/Group1483.fc2c3a20.png";